import { render } from "./create-user.vue?vue&type=template&id=68f2a1c0"
import script from "./create-user.vue?vue&type=script&lang=js"
export * from "./create-user.vue?vue&type=script&lang=js"

import "./create-user.vue?vue&type=style&index=0&id=68f2a1c0&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__